import { render, staticRenderFns } from "./vcSupplier.vue?vue&type=template&id=3fb5b20f&"
import script from "./vcSupplier.vue?vue&type=script&lang=js&"
export * from "./vcSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports